<template>
    <div class="card-content-padding">
      <div class="columns">
        <div class="column">
          <b-field>
              <b-radio-button v-model="chartSelected"
                  native-value="lesson"
                  type="is-primary">
                  <b-icon icon="chart-bar"></b-icon>
                  <span>Por Lección</span>
              </b-radio-button>

              <b-radio-button v-model="chartSelected"
                  native-value="exercise"
                  type="is-primary" :disabled="!selectedHorse">
                  <b-icon icon="chart-bar"></b-icon>
                  <span>Por Ejercicio</span>
              </b-radio-button>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <filters :selected-lesson.sync="lesson" :selected-from-date.sync="from" :selected-to-date.sync="to"></filters>
        </div>
        <div class="column is-4">
          <b-field label="Caballos" label-position="inside" v-show="chartSelected === 'lesson'">
            <horse-comparation-lessonSelect :lesson-id="lesson" :selected.sync="selectedHorses"/>
          </b-field>
        </div>
      </div>
      <lesson-chart :selected-horses="selectedHorses" :from="from" :to="to" :lesson="lesson" :selected-horse.sync="selectedHorse" :selected-exercise.sync="selectedExercise" @bar-clicked="barSelected" v-show="chartSelected === 'lesson'"/>
      <template v-if="selectedHorse">
        <exercise-chart :from="from" :to="to" :selected-horse="selectedHorse" :bar-color="selectedColor" :selected-exercise="selectedExercise" v-show="chartSelected === 'exercise'"/>
      </template>
    </div>
</template>

<script>
import HorseComparationLessonSelect from '@/components/HorseComparationLessonSelect'
import Filters from '@/components/Filters'
import LessonChart from './LessonChart'
import ExerciseChart from './ExerciseChart'

export default {
  components: {
    Filters,
    HorseComparationLessonSelect,
    LessonChart,
    ExerciseChart
  },
  data () {
    return {
      chartSelected: 'lesson',
      selectedHorses: [],
      from: null,
      to: null,
      lesson: 0,
      selectedHorse: null,
      selectedExercise: null,
      selectedColor: null
    }
  },
  methods: {
    barSelected (data) {
      this.selectedHorse = data.horse
      this.selectedExercise = data.exercise
      this.selectedColor = data.color
      this.chartSelected = 'exercise'
    },
    resetData () {
      this.selectedHorse = null
      this.selectedExercise = null
      this.selectedColor = null
      this.selectedHorses = []
      this.chartSelected = 'lesson'
    }
  },
  watch: {
    from (value) {
      this.resetData()
    },
    to (value) {
      this.resetData()
    },
    lesson (value) {
      this.resetData()
    },
    selectedHorses () {
      this.selectedHorse = null
      this.selectedExercise = null
      this.selectedColor = null
      this.chartSelected = 'lesson'
    }
  }
}
</script>
